/**
 * 简体中文商城功能文案目录
 * (`@gamecodex/world-ui` → `features/commerce`)。
 *
 * 键与功能React组件中的 `t('commerce.*')` 调用相对应。
 * 值为i18n扫描中提取的英文原始字符串的翻译。
 */
export const commerceZhCN = {
  // DtrpgClaimPage.tsx
  'commerce.dtrpg.seoTitle': '认领您的藏书',
  'commerce.dtrpg.seoDescription': '导入您的DriveThruRPG藏书，认领您的Grymwyrd PDF。',
  'commerce.dtrpg.heading': '认领您的藏书',
  'commerce.dtrpg.intro':
    '在DriveThruRPG购买了Grymwyrd或支持过众筹？用购买邮箱登录，导入您的藏书并认领您的副本。',
  'commerce.dtrpg.sendLinkError': '暂时无法发送登录链接。请稍后重试。',
  'commerce.dtrpg.checkInboxPrefix': '检查您在',
  'commerce.dtrpg.checkInboxSuffix':
    '的收件箱 — 如该邮箱有过Grymwyrd的购买或支持记录，登录链接正在路上，点击它返回此处认领您的藏书。',
  'commerce.dtrpg.linkAutoSignIn': '该链接将自动登录您 — 无需密码。',
  'commerce.dtrpg.purchaseEmailLabel': '您的购买/支持邮箱',
  'commerce.dtrpg.sendingLink': '发送链接中…',
  'commerce.dtrpg.emailLinkCta': '给我发送登录链接',
  'commerce.dtrpg.signedInAs': '登录身份',
  'commerce.dtrpg.signOut': '退出登录',
  'commerce.dtrpg.dtrpgEmailLabel': 'DriveThruRPG邮箱',
  'commerce.dtrpg.dtrpgEmailOptional': '（可选 — 如与上面不同）',
  'commerce.dtrpg.dtrpgEmailHelp': '我们用此邮箱匹配您的DriveThruRPG购买记录。',
  'commerce.dtrpg.libraryHeading': '您的Grymwyrd藏书',
  'commerce.dtrpg.noTitles': '暂无可导入的标题。',
  'commerce.dtrpg.claimNotInLibrary':
    '此标题尚未在您的藏书中。请确保您使用的是正确的购买邮箱。',
  'commerce.dtrpg.claimSessionExpired': '您的会话已过期 — 请重新登录。',
  'commerce.dtrpg.claimError': '暂时无法认领此标题。请重试。',
  'commerce.dtrpg.preparingCopy': '准备您的副本中…',
  'commerce.dtrpg.download': '下载',
  'commerce.dtrpg.preparing': '准备中…',
  'commerce.dtrpg.claiming': '认领中…',
  'commerce.dtrpg.claim': '认领',

  // PaywallPrompt.tsx
  'commerce.paywall.checkoutFailed': '无法打开结账。请稍后重试。',
  'commerce.paywall.signInToPurchase': '登录以完成此购买。',
  'commerce.paywall.vaultSealed': '商人的金库暂时已上锁 — 请稍后再试。',
  'commerce.paywall.signInToUnlock': '登录以解锁',
  'commerce.paywall.comingSoonTitle': '此购买即将推出',
  'commerce.paywall.priceComingSoon': '{price} — 即将推出',
  'commerce.paywall.comingSoon': '即将推出',
  'commerce.paywall.openingVault': '打开金库中…',
  'commerce.paywall.unlockPrice': '解锁 — {price}',
  'commerce.paywall.unlock': '解锁',

  // MarketplacePage.tsx
  'commerce.marketplace.installSuccess': '已将"{name}"装入您的牌桌。',
  'commerce.marketplace.installNotOwned': '您尚未拥有此资源包 — 资源包购买功能即将推出。',
  'commerce.marketplace.installHostOnly': '仅牌桌主持人可安装资源包。',
  'commerce.marketplace.installError': '无法安装此资源包。请重试。',
  'commerce.marketplace.installed': '已装入',
  'commerce.marketplace.installing': '装入中…',
  'commerce.marketplace.installOnTable': '装入牌桌',
  'commerce.marketplace.seoTitle': '市集 — 资源包',
  'commerce.marketplace.seoDescription':
    '浏览并安装创作者内容资源包 — 地图、场景、讲义和快速开始预设 — 到您的牌桌上。',
  'commerce.marketplace.eyebrow': '市集',
  'commerce.marketplace.heading': '内容资源包',
  'commerce.marketplace.intro':
    '地图、场景、讲义和快速开始预设 — 一键装入您的牌桌。',
  'commerce.marketplace.installingOnto': '装入至牌桌{tableId}中。',
  'commerce.marketplace.signInHeading': '登录查看您的资源包',
  'commerce.marketplace.signInBlurb': '资源包目录与您的创作者账户绑定。',
  'commerce.marketplace.signIn': '登录',
  'commerce.marketplace.loading': '召唤您的资源包中…',
  'commerce.marketplace.noPacksHeading': '暂无资源包',
  'commerce.marketplace.noPacksBlurb':
    '您还未发布任何资源包。浏览其他创作者资源包的公开市集即将推出。',
  'commerce.marketplace.footer': '浏览其他创作者的资源包和付费资源包的功能即将上线。',

  // SubscriberPerksPage.tsx
  'commerce.subscriber.perk1Title': '仅限订阅者的牌桌',
  'commerce.subscriber.perk1Blurb': '坐上您最爱的主持人为订阅者预留的牌桌。',
  'commerce.subscriber.perk2Title': '抢先与独家内容',
  'commerce.subscriber.perk2Blurb': '比其他人更早获得战役章节、场景和讲义。',
  'commerce.subscriber.perk3Title': '订阅者标识',
  'commerce.subscriber.perk3Blurb': '在您的档案和牌桌上展示您的身份。',
  'commerce.subscriber.seoTitle': '订阅者权益',
  'commerce.subscriber.seoDescription':
    '成为订阅者，获享仅限牌桌、抢先内容和订阅者标识。',
  'commerce.subscriber.heading': '成为订阅者',
  'commerce.subscriber.intro':
    '支持您热爱的主持人和创作者 — 解锁他们为内圈保留的权益。',
  'commerce.subscriber.activeHeading': '您是订阅者',
  'commerce.subscriber.activeBlurb':
    '您的权益已生效。在您可加入的牌桌上寻找订阅者徽章。',
  'commerce.subscriber.findTable': '查找订阅者牌桌',
  'commerce.subscriber.paywallTitle': 'Grymwyrd订阅者',
  'commerce.subscriber.paywallBlurb':
    '解锁仅限订阅者的牌桌、抢先内容和您的订阅者标识。',
  'commerce.subscriber.paywallPrice': '自$5/月起',

  // TicketCheckoutPage.tsx
  'commerce.ticket.checkoutFailed': '无法打开结账。请稍后重试。',
  'commerce.ticket.signInToBuy': '登录以购买此牌桌的入场券。',
  'commerce.ticket.boxOfficeClosed': '售票处暂时已关闭 — 请稍后再试。',
  'commerce.ticket.seoTitle': '购买入场券',
  'commerce.ticket.seoDescription': '预留您在计次收费牌桌中的座位。',
  'commerce.ticket.eyebrow': '计次收费牌桌',
  'commerce.ticket.heading': '预留您的座位',
  'commerce.ticket.loading': '加载牌桌中…',
  'commerce.ticket.notFoundHeading': '找不到牌桌',
  'commerce.ticket.notFoundBlurb': '此牌桌可能已关闭，或从未对外开放。',
  'commerce.ticket.backToLobby': '返回大厅',
  'commerce.ticket.freeHeading': '此牌桌免费加入',
  'commerce.ticket.freeBlurb': '无需入场券 — 来坐坐吧。',
  'commerce.ticket.goToLobby': '进入大厅',
  'commerce.ticket.untitledTable': '未命名牌桌',
  'commerce.ticket.seatPrice': '座位价格',
  'commerce.ticket.spectatorsNote': '旁观者也必须持有此牌桌的入场券。',
  'commerce.ticket.paymentReceived': '已收到款项 — 您的座位已预留。前往大厅落座。',
  'commerce.ticket.signInToBuySeat': '登录以购买座位',
  'commerce.ticket.openingBoxOffice': '打开售票处中…',
  'commerce.ticket.buySeatPrice': '购买座位 — {price}',
  'commerce.ticket.comingSoonTitle': '计次收费即将推出',
  'commerce.ticket.ticketingComingSoon': '计次收费即将推出',
  'commerce.ticket.comingSoonFooter': '付费座位即将就绪。暂时请向主持人申请免费邀请。',

  // TipGoalManagerPage.tsx
  'commerce.tip.errHostOnlyGoal': '仅牌桌主持人可管理目标。',
  'commerce.tip.errHostOnlyBounty': '仅牌桌主持人可管理悬赏。',
  'commerce.tip.errMaxGoal': '您已达到此牌桌的目标数量上限。',
  'commerce.tip.errMaxBounty': '您已达到此牌桌的悬赏数量上限。',
  'commerce.tip.errMissingGoal': '该目标缺少必需的详情。',
  'commerce.tip.errMissingBounty': '该悬赏缺少必需的详情。',
  'commerce.tip.errSignIn': '以主持人身份登录来管理此牌桌。',
  'commerce.tip.errSaveFailedGoal': '无法保存目标。请重试。',
  'commerce.tip.errSaveFailedBounty': '无法保存悬赏。请重试。',
  'commerce.tip.goalValidation': '添加标签和正金额目标。',
  'commerce.tip.goalAdded': '目标"{label}"已添加。',
  'commerce.tip.goalLabelPlaceholder': '目标标签（例如 召唤Boss）',
  'commerce.tip.targetPlaceholder': '目标$',
  'commerce.tip.cuePlaceholder': '达成时提示（例如 喝彩声）',
  'commerce.tip.addGoal': '添加目标',
  'commerce.tip.bountyValidation': '添加标签、正目标和触发条件。',
  'commerce.tip.bountyAdded': '悬赏"{label}"已添加。',
  'commerce.tip.bountyLabelPlaceholder': '悬赏标签（例如 天然20救队伍）',
  'commerce.tip.triggerPlaceholder': '触发条件（例如 天然20）',
  'commerce.tip.addBounty': '添加悬赏',
  'commerce.tip.signInToManage': '登录来管理此牌桌。',
  'commerce.tip.bountyClaimed': '悬赏"{label}"已认领。',
  'commerce.tip.seoTitle': '提示目标与悬赏',
  'commerce.tip.seoDescription': '为您的牌桌设置提示目标和悬赏。',
  'commerce.tip.backToLobby': '返回大厅',
  'commerce.tip.heading': '提示目标与悬赏',
  'commerce.tip.intro':
    '为您的牌桌设置目标和悬赏。当提示杯满溢时，提示音会为您的观众播放。直播显示由您的广播叠层处理。',
  'commerce.tip.loading': '读取账本中…',
  'commerce.tip.loadErrorTitle': '无法加载账本',
  'commerce.tip.raisedSoFar': '目前筹得：',
  'commerce.tip.tipGoalsHeading': '提示目标',
  'commerce.tip.noGoals': '暂无目标 — 在下方添加第一个。',
  'commerce.tip.reachedAria': '达成',
  'commerce.tip.bountiesHeading': '悬赏',
  'commerce.tip.noBounties': '暂无悬赏 — 在下方添加第一个。',
  'commerce.tip.whenLabel': '· 当：{trigger}',
  'commerce.tip.claimed': '已认领',
  'commerce.tip.claimTitleReady': '标记此悬赏为已认领',
  'commerce.tip.claimTitleNotFunded': '尚未筹得',
  'commerce.tip.claim': '认领',
} as const
